import { Component, OnInit } from '@angular/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SliderDto } from 'src/app/shared/dtos/sliderDto';
import { SliderService } from 'src/app/shared/services/slider.service';
import { NotificationService } from 'src/app/shared/services/notification.service';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
})
export class AdminSliderComponent implements OnInit {
  sliders: SliderDto[] = [];
  showDeleteConfirm: boolean = false;
  sliderToDelete: number | null = null;

  constructor(
    private sliderService: SliderService,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.getSliders();
  }

  async getSliders(): Promise<void> {
    try {
      this.sliders = await this.sliderService.getSliders();
    } catch (error) {
      this.notificationService.showError('Sliderlar yüklenirken bir hata oluştu');
    } 
  }

  addSlider(): void {
    this.sliders.unshift(new SliderDto(0, '', '', '', '','','','',''));
  }

  confirmDelete(index: number): void {
    this.sliderToDelete = index;
    this.showDeleteConfirm = true;
  }

  cancelDelete(): void {
    this.showDeleteConfirm = false;
    this.sliderToDelete = null;
  }

  async confirmDeleteSlider(): Promise<void> {
    if (this.sliderToDelete !== null) {
      try {
        this.sliders.splice(this.sliderToDelete, 1);
        await this.sliderService.saveSliders(this.sliders);
        this.notificationService.show('Slider başarıyla silindi');
      } catch (error) {
        this.notificationService.showError('Slider silinirken bir hata oluştu');
      } finally {
        this.showDeleteConfirm = false;
        this.sliderToDelete = null;
      }
    }
  }

  async removeSlider(index: number): Promise<void> {
    try {
      this.sliders.splice(index, 1);
      await this.sliderService.saveSliders(this.sliders);
      this.notificationService.show('Slider başarıyla silindi');
    } catch (error) {
      this.notificationService.showError('Slider silinirken bir hata oluştu');
    } 
  }
  

  async onFileSelected(base64: any, item: SliderDto) {
  item.selectedFileBase64 = base64;
  item.imageUrl = base64; // geçici gösterim

  try {
    await this.sliderService.saveSliders(this.sliders); // dönüş beklemiyoruz
    await this.getSliders();
    this.notificationService.show('Resim başarıyla yüklendi');
  } catch (error) {
    this.notificationService.showError('Resim yüklenirken bir hata oluştu');
  }
}

  async saveSliders(): Promise<void> {
    try {
      await this.sliderService.saveSliders(this.sliders);
      this.notificationService.show('Slider başarıyla kaydedildi');
    } catch (error) {
      this.notificationService.showError('Sliderlar kaydedilirken bir hata oluştu');
    } 
  }
}